import type { Meta, StoryObj } from '@storybook/angular';
import { expect, within } from 'storybook/test';
import { ModalContainerComponent } from '../../../app/content/layout/components/modals/modal-container/modal-container.component';
import { withCommonDecorators } from '../../_utils/story-helpers';

const meta: Meta<ModalContainerComponent> = {
  title: 'Molecules/Modals/Modal Container',
  component: ModalContainerComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
  parameters: {
    docs: {
      description: {
        component: 'Base modal container used to wrap all modals. Provides title, header slot, body content, and footer slot with a close button.',
      },
    },
  },
};
export default meta;
type Story = StoryObj<ModalContainerComponent>;

export const WithTitle: Story = {
  args: { title: 'Modal Overskrift' },
  render: (args) => ({
    props: args,
    template: `
      <app-modal-container [title]="title">
        <p>Dette er indholdet af modalen. Her kan du placere enhver indholdstype.</p>
      </app-modal-container>
    `,
  }),
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/modal overskrift/i)).toBeInTheDocument();
  },
};

export const WithFooter: Story = {
  render: () => ({
    template: `
      <app-modal-container title="Bekræft handling">
        <p>Er du sikker på at du vil fortsætte?</p>
        <button footer class="btn btn-primary">Bekræft</button>
      </app-modal-container>
    `,
  }),
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/bekræft handling/i)).toBeInTheDocument();
  },
};

export const LargeModal: Story = {
  args: { title: 'Stor Modal', largeModal: true },
  render: (args) => ({
    props: args,
    template: `
      <app-modal-container [title]="title" [largeModal]="largeModal">
        <p>Denne modal bruger det brede layout til mere indhold.</p>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
      </app-modal-container>
    `,
  }),
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/stor modal/i)).toBeInTheDocument();
  },
};

export const NoTitle: Story = {
  render: () => ({
    template: `
      <app-modal-container>
        <div title>
          <span style="font-weight: bold; color: #8B0000;">Custom Header Content</span>
        </div>
        <p>Modal med brugerdefineret header via title slot.</p>
      </app-modal-container>
    `,
  }),
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/custom header content/i)).toBeInTheDocument();
  },
};
